import React from 'react';

export default function Results( props ) {
	const { error, loading, result, onFocusLine } = props;
	if ( error ) {
		return (
			<div className="Results col-md-6">
				<h2 className="my-3 text-monospace h5">Error while loading results</h2>
				<pre className="my-3">
					<code>
						{ error.message ? error.message : JSON.stringify( error, null, 2 ) }
					</code>
				</pre>
			</div>
		);
	}

	if ( ! result ) {
		return (
			<div className="Results col-md-6">
				<pre className="my-3">
					<code>
						{ loading ? 'Checking…' : (
							<>
								Enter code in the editor on the left, then hit "Check code" to run{'\n'}
								hm-linter's checks (phpcs, eslint, and stylelint).{'\n\n'}
								The results will be displayed here.
							</>
						) }
					</code>
				</pre>
			</div>
		);
	}

	return (
		<div className="Results col-md-6">
			<div className="my-3">
				{ Object.keys( result ).map( filename => (
					<React.Fragment
						key={ filename }
					>
						{ result[ filename ].length === 0 ? (
							<div className="Results__result card mb-3">
								<div className="card-body border-left border-success">
									<p className="my-0">All linters passed</p>
								</div>
							</div>
						) : result[ filename ].map( ( item, idx ) => (
							<div
								key={ idx }
								className="Results__result card mb-3"
							>
								<div
									className={ `card-body border-left ${ item.severity === 'error' ? 'border-danger' : 'border-warning' }` }
								>
									<p className="card-subtitle text-muted mb-2 small">
										Check failure on line { item.line } in { filename }
									</p>
									<p
										className="mb-2"
									>
										<button
											className={ [
												'bg-transparent',
												'border-0',
												'p-0',
												'font-weight-bold',
												item.severity === 'error' ? 'text-danger' : 'text-warning',
											].join( ' ' ) }
											type="button"
											onClick={ e => { e.preventDefault(); onFocusLine( item.line ); } }
										>
											{ filename }#L{ item.line }
										</button>
									</p>
									<p className="text-monospace small">{ item.message }</p>

									<details>
										<summary className="btn btn-outline-primary btn-sm">
											Raw output
										</summary>

										<pre className="Results__raw pre-scrollable py-3 px-2">
											<code>
												{ JSON.stringify( item, null, 2 ) }
											</code>
										</pre>
									</details>
								</div>
							</div>
						) ) }
					</React.Fragment>
				) ) }
			</div>
			<details className="mb-3">
				<summary className="btn btn-outline-primary btn-sm">
					Raw response
				</summary>
				<pre className="my-3">
					<code>
						{ JSON.stringify( result, null, "\t" ) }
					</code>
				</pre>
			</details>
		</div>
	);
}
